import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { PeoplePage } from "@/features/domain/components/people-page";
import { useI18n } from "@/providers/i18n-provider";

function PeopleRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`People`)}
      description={t(msg`Sign in to see the people directory your account has access to.`)}
    >
      <PageContainer maxWidth="3xl">
        <PeoplePage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const peopleRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/people",
  component: PeopleRoutePage,
});
